module.exports = __webpack_public_path__ + "img/57ne.5d97029c.svg";